export default "__VITE_ASSET__CA2dL6ys__"